import React, { useState } from "react";
import PageWrapper from "./components/PageWrapper";
import { useFormCtx } from "./FormContext";

import * as Const from "./_Const";

import Keyboard from "./components/Keyboard";
import Select from "./components/Select";

import Button from "./components/Button";
import TransitionBlock from "./components/TransitionBlock";

const insurance = [
  {
    value: "111",
    abrevation: "VZP",
    label: "Všeobecná zdravotní pojišťovna ČR",
  },
  {
    value: "201",
    abrevation: "VOZP",
    label: "Vojenská zdravotní pojišťovna ČR",
  },
  {
    value: "205",
    abrevation: "ČPZP",
    label: "Česká průmyslová zdravotní pojišťovna",
  },
  {
    value: "207",
    abrevation: "OZP",
    label: "Oborová zdravotní pojišťovna zaměstnanců bank, pojišťoven a stavebnictví",
  },
  {
    value: "209",
    abrevation: "ZP ŠKODA",
    label: "Zaměstnanecká pojišťovna ŠKODA",
  },
  {
    value: "211",
    abrevation: "ZP MV ČR",
    label: "Zdravotní pojišťovna Ministerstva vnitra ČR",
  },
  {
    value: "213",
    abrevation: "RBP",
    label: "Revírní bratrská pokladna, zdravotní pojišťovna",
  },
  {
    value: "300",
    abrevation: "samoplátce",
    label: "samoplátce",
  },
];

function PagePersonalInsuranceCompany({ onNext, onPrev, test = false }) {
  const [fade, setFade] = useState(false);
  const [fadeIndex, setFadeIndex] = useState(-1);
  const {
    getPageData,
    handleInputWithKeyboard,
    state,
    setCurrentStepIndex,
    isEmptyState,
    navigateNextButtons,
    navigateNextInsuranceButton,
    isAnimationDisabled,
  } = useFormCtx();
  const pageIndex = Const.REG_RPI_INUSRANCE_COMPANY_INDEX;
  const page = getPageData(pageIndex);

  const isTerminal = Const.isTerminal();
  const textCss = isTerminal ? "text-lg mt-3" : "text-sm mt-4";

  function canWrapTitle(title) {
    let canWrap = false;

    const len = title?.length ?? 0;
    // console.log(len);

    if (len > 25) {
      canWrap = true;
    }
    // console.log(title, len, canWrap);
    return canWrap;
  }

  function replaceWithBr(text, canWrap) {
    if (canWrap && text) {
      return text.replace(/\n/g, "<br />");
    }
    return text;
  }

  function handleClick(item) {
    if (!test) {
      setTimeout(() => navigateNextInsuranceButton(item, pageIndex), 250);
    }
  }

  const showTitle = !isTerminal;
  const delay = isTerminal ? 0 : 0.01;

  return (
    <>
      <PageWrapper title={page.title} index={pageIndex} showTitle={showTitle}>
        {showTitle && <h2 className="mt-6 text-xl font-light text-primary mx-6">{page.subtitle}</h2>}
        <div className="mt-4 grid grid-cols-2 gap-4 mx-6">
          {insurance &&
            insurance.map((item, aIndex) => (
              <TransitionBlock key={item.value} delay={delay * aIndex}>
                <button
                  onClick={() => handleClick(item)}
                  className={
                    "h-32 grid grid-cols-[2fr_6fr] active:bg-accent-dark active:text-accent-secondary group min-h-12 font-bold text-xl justify-items-start rounded-2xl uppercase shadow-md text-accent-dark bg-accent-secondary w-full"
                  }
                >
                  <span className="row-span-3a justify-self-center self-center text-3xl">{item.value}</span>
                  <div className="grid grid-rows-2 self-center">
                    <span className="text-left self-end text-2xl">{item.abrevation}</span>
                    <span className="text-left font-normal text-sm" dangerouslySetInnerHTML={{ __html: replaceWithBr(item.label, canWrapTitle(item.label)) }} />
                  </div>
                </button>
              </TransitionBlock>
            ))}
        </div>

        <p className={`${textCss} mx-6  text-secondary font-light`}>Kliknutím na jedno z tlačítek přejdete na další obrazovku</p>
      </PageWrapper>
    </>
  );
}

export default PagePersonalInsuranceCompany;
